import React, { useEffect, useRef, useState } from 'react'
import imagenes2 from '../../images/Imagenes2.js'
import '../../style/components/Slider.css'
import { motion } from 'framer-motion/dist/framer-motion'

const Slider2 = () => {
  const containerRef = useRef(null)
  const trackRef = useRef(null)
  const [dragLimit, setDragLimit] = useState(0)

  useEffect(() => {
    const calcularLimite = () => {
      if (containerRef.current && trackRef.current) {
        const anchoContenedor = containerRef.current.offsetWidth
        const anchoTotal = trackRef.current.scrollWidth
        setDragLimit(Math.max(anchoTotal - anchoContenedor, 0))
      }
    }
    calcularLimite()
    window.addEventListener('resize', calcularLimite)
    return () => window.removeEventListener('resize', calcularLimite)
  }, [])

  return (
    <motion.div className='silderContainer' ref={containerRef}>
      <motion.div
        className='slider'
        ref={trackRef}
        drag='x'
        dragConstraints={{ right: 0, left: -dragLimit }}
      >
        {imagenes2.map((imagen, index) => (
          <motion.div className='item' key={index}>
            <img src={imagen} alt='' />
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  )
}

export { Slider2 }